import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const SolucionesEmpresas = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-16 md:pt-40 md:pb-24 lg:pb-32 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-700 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0"></div>
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center text-white mb-12 md:mb-16">
            <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-6 md:mb-8 border border-white/20">
              <i className="ri-building-2-line text-base md:text-lg"></i>
              <span className="text-sm md:text-base font-medium">Soluciones B2B</span>
            </div>
            
            <h1 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold mb-4 md:mb-6 leading-tight">
              Soluciones Integrales para tu Empresa
            </h1>
            
            <p className="text-base md:text-lg lg:text-xl mb-8 md:mb-10 opacity-95 max-w-3xl mx-auto">
              Suministro estratégico de insumos empresariales con entregas oportunas, precios competitivos y asesoría especializada para potenciar la productividad de tu negocio.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center mb-12 md:mb-16">
              <Link
                to="/contacto"
                className="inline-flex items-center justify-center gap-2 bg-white text-blue-800 px-6 md:px-8 py-3 md:py-4 rounded-lg font-semibold hover:bg-gray-100 transition-all shadow-lg whitespace-nowrap cursor-pointer w-full sm:w-auto"
              >
                <i className="ri-mail-line text-lg md:text-xl"></i>
                Solicitar Cotización
              </Link>
              <Link
                to="/catalogo"
                className="inline-flex items-center justify-center gap-2 bg-blue-900/50 backdrop-blur-sm text-white px-6 md:px-8 py-3 md:py-4 rounded-lg font-semibold hover:bg-blue-900/70 transition-all border border-white/20 whitespace-nowrap cursor-pointer w-full sm:w-auto"
              >
                <i className="ri-folder-open-line text-lg md:text-xl"></i>
                Ver Catálogo
              </Link>
            </div>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 lg:gap-8">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 md:p-6 border border-white/20">
                <div className="text-3xl md:text-4xl font-bold mb-2">+250</div>
                <div className="text-sm md:text-base opacity-90">Productos en Stock</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 md:p-6 border border-white/20">
                <div className="text-3xl md:text-4xl font-bold mb-2">+150</div>
                <div className="text-sm md:text-base opacity-90">Marcas Disponibles</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 md:p-6 border border-white/20">
                <div className="text-3xl md:text-4xl font-bold mb-2">24-48h</div>
                <div className="text-sm md:text-base opacity-90">Tiempo de Cotización</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 md:p-6 border border-white/20">
                <div className="text-3xl md:text-4xl font-bold mb-2">98%</div>
                <div className="text-sm md:text-base opacity-90">Satisfacción Cliente</div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Proceso de Suministro */}
      <section id="proceso" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-8 lg:px-16">
          <div className="text-center mb-16 transition-all duration-1000 opacity-100 translate-y-0">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">Proceso de Suministro Empresarial</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Un flujo de trabajo optimizado para que tu empresa nunca se quede sin insumos
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Paso 1 */}
            <div className="relative transition-all duration-700 opacity-100 translate-y-0">
              <div className="hidden lg:block absolute top-16 left-full w-full h-0.5 bg-gradient-to-r from-blue-300 to-blue-500 transform -translate-x-1/2 z-0"></div>
              <div className="relative bg-gradient-to-br from-blue-50 to-white rounded-xl p-8 shadow-md hover:shadow-xl transition-all duration-300 h-full border border-blue-100">
                <div className="absolute -top-4 -left-4 w-10 h-10 bg-blue-700 text-white rounded-full flex items-center justify-center font-bold text-lg shadow-lg">
                  1
                </div>
                <div className="w-16 h-16 bg-blue-700 rounded-lg flex items-center justify-center mb-6 mx-auto">
                  <i className="ri-file-list-3-line text-3xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3 text-center">Requisición</h3>
                <div className="inline-block bg-blue-100 text-blue-700 px-4 py-1 rounded-full text-sm font-semibold mb-4 w-full text-center">
                  <i className="ri-time-line mr-1"></i>Inmediato
                </div>
                <p className="text-gray-600 leading-relaxed text-center">
                  Envía tu lista de productos por WhatsApp, correo o nuestro formulario web. Acepta cualquier formato.
                </p>
              </div>
            </div>
            
            {/* Paso 2 */}
            <div className="relative transition-all duration-700 opacity-100 translate-y-0">
              <div className="hidden lg:block absolute top-16 left-full w-full h-0.5 bg-gradient-to-r from-blue-300 to-blue-500 transform -translate-x-1/2 z-0"></div>
              <div className="relative bg-gradient-to-br from-blue-50 to-white rounded-xl p-8 shadow-md hover:shadow-xl transition-all duration-300 h-full border border-blue-100">
                <div className="absolute -top-4 -left-4 w-10 h-10 bg-blue-700 text-white rounded-full flex items-center justify-center font-bold text-lg shadow-lg">
                  2
                </div>
                <div className="w-16 h-16 bg-blue-700 rounded-lg flex items-center justify-center mb-6 mx-auto">
                  <i className="ri-calculator-line text-3xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3 text-center">Cotización</h3>
                <div className="inline-block bg-blue-100 text-blue-700 px-4 py-1 rounded-full text-sm font-semibold mb-4 w-full text-center">
                  <i className="ri-time-line mr-1"></i>24-48 horas
                </div>
                <p className="text-gray-600 leading-relaxed text-center">
                  Recibe una cotización detallada con precios competitivos y disponibilidad en un plazo de 24 a 48 horas.
                </p>
              </div>
            </div>
            
            {/* Paso 3 */}
            <div className="relative transition-all duration-700 opacity-100 translate-y-0">
              <div className="hidden lg:block absolute top-16 left-full w-full h-0.5 bg-gradient-to-r from-blue-300 to-blue-500 transform -translate-x-1/2 z-0"></div>
              <div className="relative bg-gradient-to-br from-blue-50 to-white rounded-xl p-8 shadow-md hover:shadow-xl transition-all duration-300 h-full border border-blue-100">
                <div className="absolute -top-4 -left-4 w-10 h-10 bg-blue-700 text-white rounded-full flex items-center justify-center font-bold text-lg shadow-lg">
                  3
                </div>
                <div className="w-16 h-16 bg-blue-700 rounded-lg flex items-center justify-center mb-6 mx-auto">
                  <i className="ri-checkbox-circle-line text-3xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3 text-center">Confirmación</h3>
                <div className="inline-block bg-blue-100 text-blue-700 px-4 py-1 rounded-full text-sm font-semibold mb-4 w-full text-center">
                  <i className="ri-time-line mr-1"></i>15 minutos
                </div>
                <p className="text-gray-600 leading-relaxed text-center">
                  Aprueba la cotización y confirma tu pedido. Ofrecemos crédito empresarial *Bajo consideración por parte de CX y múltiples formas de pago.
                </p>
              </div>
            </div>
            
            {/* Paso 4 */}
            <div className="relative transition-all duration-700 opacity-100 translate-y-0">
              <div className="relative bg-gradient-to-br from-blue-50 to-white rounded-xl p-8 shadow-md hover:shadow-xl transition-all duration-300 h-full border border-blue-100">
                <div className="absolute -top-4 -left-4 w-10 h-10 bg-blue-700 text-white rounded-full flex items-center justify-center font-bold text-lg shadow-lg">
                  4
                </div>
                <div className="w-16 h-16 bg-blue-700 rounded-lg flex items-center justify-center mb-6 mx-auto">
                  <i className="ri-truck-line text-3xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3 text-center">Entrega + Facturación</h3>
                <div className="inline-block bg-blue-100 text-blue-700 px-4 py-1 rounded-full text-sm font-semibold mb-4 w-full text-center">
                  <i className="ri-time-line mr-1"></i>24-48 horas
                </div>
                <p className="text-gray-600 leading-relaxed text-center">
                  Entrega en Puebla y zona metropolitana. Servicio de facturación con todos los requisitos fiscales.
                </p>
              </div>
            </div>
          </div>
          
          <div className="mt-16 bg-gradient-to-r from-blue-700 to-blue-900 rounded-2xl p-10 text-center transition-all duration-1000 delay-700 opacity-100 translate-y-0">
            <div className="flex items-center justify-center mb-4">
              <div className="w-20 h-20 flex items-center justify-center">
                <i className="ri-medal-line text-5xl text-yellow-400"></i>
              </div>
            </div>
            <h3 className="text-5xl font-bold text-white mb-2">98%</h3>
            <p className="text-xl font-semibold text-yellow-400 mb-4">Satisfacción del Cliente</p>
            <p className="text-lg text-white/90 max-w-3xl mx-auto">
              Nuestros clientes empresariales nos respaldan. El <strong>98% de las empresas</strong> que trabajan con nosotros renuevan su relación comercial, gracias a nuestro servicio confiable, tiempos de respuesta cumplidos y atención personalizada.
            </p>
          </div>
        </div>
      </section>
      
      {/* Beneficios Exclusivos B2B */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
        <div className="max-w-7xl mx-auto px-8 lg:px-16">
          <div className="text-center mb-16 transition-all duration-1000 opacity-100 translate-y-0">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">Beneficios Exclusivos B2B</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Ventajas diseñadas específicamente para empresas que buscan eficiencia y ahorro
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Beneficio 1 */}
            <div className="bg-white rounded-xl p-8 shadow-md hover:shadow-xl transition-all duration-500 hover:-translate-y-2 opacity-100 translate-y-0">
              <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-price-tag-3-line text-3xl text-blue-700"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">Precios Competitivos</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                Descuentos por volumen y precios especiales para clientes corporativos. Cotizaciones personalizadas según tus necesidades.
              </p>
              <ul className="space-y-2">
                <li className="flex items-start gap-2 text-sm text-gray-700">
                  <i className="ri-checkbox-circle-fill text-blue-700 mt-0.5"></i>
                  <span>Descuentos escalonados</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-gray-700">
                  <i className="ri-checkbox-circle-fill text-blue-700 mt-0.5"></i>
                  <span>Precios mayoristas</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-gray-700">
                  <i className="ri-checkbox-circle-fill text-blue-700 mt-0.5"></i>
                  <span>Sin mínimos de compra</span>
                </li>
              </ul>
            </div>
            
            {/* Beneficio 2 */}
            <div className="bg-white rounded-xl p-8 shadow-md hover:shadow-xl transition-all duration-500 hover:-translate-y-2 opacity-100 translate-y-0">
              <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-bank-card-line text-3xl text-blue-700"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">Crédito Empresarial</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                Línea de crédito flexible para empresas establecidas. Facilita tu flujo de caja con plazos de pago extendidos.
              </p>
              <ul className="space-y-2">
                <li className="flex items-start gap-2 text-sm text-gray-700">
                  <i className="ri-checkbox-circle-fill text-blue-700 mt-0.5"></i>
                  <span>Hasta 30 días de crédito</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-gray-700">
                  <i className="ri-checkbox-circle-fill text-blue-700 mt-0.5"></i>
                  <span>Proceso de aprobación rápido</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-gray-700">
                  <i className="ri-checkbox-circle-fill text-blue-700 mt-0.5"></i>
                  <span>Sin intereses</span>
                </li>
              </ul>
            </div>
            
            {/* Beneficio 3 */}
            <div className="bg-white rounded-xl p-8 shadow-md hover:shadow-xl transition-all duration-500 hover:-translate-y-2 opacity-100 translate-y-0">
              <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-file-text-line text-3xl text-blue-700"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">Servicio de Facturación</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                Emitimos tu factura electrónica CFDI 4.0 de forma ágil y con todos los requisitos fiscales vigentes.
              </p>
              <ul className="space-y-2">
                <li className="flex items-start gap-2 text-sm text-gray-700">
                  <i className="ri-checkbox-circle-fill text-blue-700 mt-0.5"></i>
                  <span>CFDI 4.0</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-gray-700">
                  <i className="ri-checkbox-circle-fill text-blue-700 mt-0.5"></i>
                  <span>Portal de facturas</span>
                </li>
              </ul>
            </div>
            
            {/* Beneficio 4 */}
            <div className="bg-white rounded-xl p-8 shadow-md hover:shadow-xl transition-all duration-500 hover:-translate-y-2 opacity-100 translate-y-0">
              <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-truck-line text-3xl text-blue-700"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">Entrega Programada</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                Programa entregas recurrentes de tus productos más utilizados. Nunca te quedes sin insumos críticos.
              </p>
              <ul className="space-y-2">
                <li className="flex items-start gap-2 text-sm text-gray-700">
                  <i className="ri-checkbox-circle-fill text-blue-700 mt-0.5"></i>
                  <span>Entregas semanales/mensuales</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-gray-700">
                  <i className="ri-checkbox-circle-fill text-blue-700 mt-0.5"></i>
                  <span>Horarios flexibles</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-gray-700">
                  <i className="ri-checkbox-circle-fill text-blue-700 mt-0.5"></i>
                  <span>Seguimiento en tiempo real</span>
                </li>
              </ul>
            </div>
            
            {/* Beneficio 5 */}
            <div className="bg-white rounded-xl p-8 shadow-md hover:shadow-xl transition-all duration-500 hover:-translate-y-2 opacity-100 translate-y-0">
              <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-customer-service-2-line text-3xl text-blue-700"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">Ejecutivo Dedicado</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                Un ejecutivo de cuenta asignado que conoce tu empresa y anticipa tus necesidades de suministro.
              </p>
              <ul className="space-y-2">
                <li className="flex items-start gap-2 text-sm text-gray-700">
                  <i className="ri-checkbox-circle-fill text-blue-700 mt-0.5"></i>
                  <span>Atención personalizada</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-gray-700">
                  <i className="ri-checkbox-circle-fill text-blue-700 mt-0.5"></i>
                  <span>Respuesta prioritaria</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-gray-700">
                  <i className="ri-checkbox-circle-fill text-blue-700 mt-0.5"></i>
                  <span>Asesoría especializada</span>
                </li>
              </ul>
            </div>
            
            {/* Beneficio 6 */}
            <div className="bg-white rounded-xl p-8 shadow-md hover:shadow-xl transition-all duration-500 hover:-translate-y-2 opacity-100 translate-y-0">
              <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-lightbulb-line text-3xl text-blue-700"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">Asesoría para PyMEs</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                Apoyamos a pequeñas y medianas empresas con cotizaciones starter adaptadas a su presupuesto y escala. Ideal para negocios que están comenzando y necesitan un proveedor confiable desde el primer día.
              </p>
              <ul className="space-y-2">
                <li className="flex items-start gap-2 text-sm text-gray-700">
                  <i className="ri-checkbox-circle-fill text-blue-700 mt-0.5"></i>
                  <span>Cotizaciones starter</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-gray-700">
                  <i className="ri-checkbox-circle-fill text-blue-700 mt-0.5"></i>
                  <span>Precios accesibles para nuevas empresas</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-gray-700">
                  <i className="ri-checkbox-circle-fill text-blue-700 mt-0.5"></i>
                  <span>Acompañamiento en primeras compras</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      
      {/* Sectores que Atendemos */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-8 lg:px-16">
          <div className="text-center mb-16 transition-all duration-1000 opacity-100 translate-y-0">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">Sectores que Atendemos</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Experiencia comprobada en múltiples industrias con soluciones adaptadas a cada sector
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Sector 1 */}
            <div className="group bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-500 hover:-translate-y-2 opacity-100 translate-y-0">
              <div className="relative h-48 overflow-hidden">
                <img
                  alt="Sector Salud"
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  src="https://public.readdy.ai/ai/img_res/b59a8be86d4b2533131129c2cdd09e2b.jpg"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-blue-900/70 to-transparent"></div>
                <div className="absolute top-4 right-4 w-12 h-12 bg-white rounded-lg flex items-center justify-center shadow-lg">
                  <i className="ri-hospital-line text-2xl text-blue-700"></i>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Sector Salud</h3>
                <p className="text-gray-600 mb-4">Hospitales, clínicas y consultorios médicos</p>
                <div className="border-t border-gray-200 pt-4">
                  <p className="text-sm font-semibold text-gray-700 mb-2">Productos destacados:</p>
                  <ul className="space-y-1">
                    <li className="flex items-start gap-2 text-sm text-gray-600">
                      <i className="ri-checkbox-circle-line text-blue-700 mt-0.5"></i>
                      <span>Material de oficina médica</span>
                    </li>
                    <li className="flex items-start gap-2 text-sm text-gray-600">
                      <i className="ri-checkbox-circle-line text-blue-700 mt-0.5"></i>
                      <span>Consumibles administrativos</span>
                    </li>
                    <li className="flex items-start gap-2 text-sm text-gray-600">
                      <i className="ri-checkbox-circle-line text-blue-700 mt-0.5"></i>
                      <span>Papelería especializada</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            
            {/* Sector 2 */}
            <div className="group bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-500 hover:-translate-y-2 opacity-100 translate-y-0">
              <div className="relative h-48 overflow-hidden">
                <img
                  alt="Sector Público"
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  src="https://public.readdy.ai/ai/img_res/b37ee900c42e6b705ae762f66f4e19ab.jpg"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-blue-900/70 to-transparent"></div>
                <div className="absolute top-4 right-4 w-12 h-12 bg-white rounded-lg flex items-center justify-center shadow-lg">
                  <i className="ri-government-line text-2xl text-blue-700"></i>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Sector Público</h3>
                <p className="text-gray-600 mb-4">Dependencias gubernamentales y municipales</p>
                <div className="border-t border-gray-200 pt-4">
                  <p className="text-sm font-semibold text-gray-700 mb-2">Productos destacados:</p>
                  <ul className="space-y-1">
                    <li className="flex items-start gap-2 text-sm text-gray-600">
                      <i className="ri-checkbox-circle-line text-blue-700 mt-0.5"></i>
                      <span>Suministros para licitaciones</span>
                    </li>
                    <li className="flex items-start gap-2 text-sm text-gray-600">
                      <i className="ri-checkbox-circle-line text-blue-700 mt-0.5"></i>
                      <span>Facturación fiscal</span>
                    </li>
                    <li className="flex items-start gap-2 text-sm text-gray-600">
                      <i className="ri-checkbox-circle-line text-blue-700 mt-0.5"></i>
                      <span>Entregas programadas</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            
            {/* Sector 3 */}
            <div className="group bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-500 hover:-translate-y-2 opacity-100 translate-y-0">
              <div className="relative h-48 overflow-hidden">
                <img
                  alt="Corporativos"
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  src="https://readdy.ai/api/search-image?query=modern%20corporate%20office%20workspace%20with%20multiple%20workstations%20organized%20supplies%20professional%20business%20environment%20contemporary%20furniture%20natural%20lighting%20productive%20atmosphere%20clean%20design&width=600&height=400&seq=sector-corporativo-img&orientation=landscape"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-blue-900/70 to-transparent"></div>
                <div className="absolute top-4 right-4 w-12 h-12 bg-white rounded-lg flex items-center justify-center shadow-lg">
                  <i className="ri-building-line text-2xl text-blue-700"></i>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Corporativos</h3>
                <p className="text-gray-600 mb-4">Empresas medianas y grandes</p>
                <div className="border-t border-gray-200 pt-4">
                  <p className="text-sm font-semibold text-gray-700 mb-2">Productos destacados:</p>
                  <ul className="space-y-1">
                    <li className="flex items-start gap-2 text-sm text-gray-600">
                      <i className="ri-checkbox-circle-line text-blue-700 mt-0.5"></i>
                      <span>Suministro continuo</span>
                    </li>
                    <li className="flex items-start gap-2 text-sm text-gray-600">
                      <i className="ri-checkbox-circle-line text-blue-700 mt-0.5"></i>
                      <span>Crédito empresarial</span>
                    </li>
                    <li className="flex items-start gap-2 text-sm text-gray-600">
                      <i className="ri-checkbox-circle-line text-blue-700 mt-0.5"></i>
                      <span>Ejecutivo dedicado</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            
            {/* Sector 4 */}
            <div className="group bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-500 hover:-translate-y-2 opacity-100 translate-y-0">
              <div className="relative h-48 overflow-hidden">
                <img
                  alt="Retail y Comercio"
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  src="https://readdy.ai/api/search-image?query=retail%20store%20back%20office%20workspace%20with%20organized%20supplies%20inventory%20management%20area%20professional%20commercial%20environment%20clean%20organized%20space%20contemporary%20design%20natural%20lighting&width=600&height=400&seq=sector-retail-img&orientation=landscape"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-blue-900/70 to-transparent"></div>
                <div className="absolute top-4 right-4 w-12 h-12 bg-white rounded-lg flex items-center justify-center shadow-lg">
                  <i className="ri-store-2-line text-2xl text-blue-700"></i>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Retail y Comercio</h3>
                <p className="text-gray-600 mb-4">Tiendas, franquicias y puntos de venta</p>
                <div className="border-t border-gray-200 pt-4">
                  <p className="text-sm font-semibold text-gray-700 mb-2">Productos destacados:</p>
                  <ul className="space-y-1">
                    <li className="flex items-start gap-2 text-sm text-gray-600">
                      <i className="ri-checkbox-circle-line text-blue-700 mt-0.5"></i>
                      <span>Consumibles POS</span>
                    </li>
                    <li className="flex items-start gap-2 text-sm text-gray-600">
                      <i className="ri-checkbox-circle-line text-blue-700 mt-0.5"></i>
                      <span>Material de empaque</span>
                    </li>
                    <li className="flex items-start gap-2 text-sm text-gray-600">
                      <i className="ri-checkbox-circle-line text-blue-700 mt-0.5"></i>
                      <span>Suministros operativos</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            
            {/* Sector 5 */}
            <div className="group bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-500 hover:-translate-y-2 opacity-100 translate-y-0">
              <div className="relative h-48 overflow-hidden">
                <img
                  alt="Educación"
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  src="https://readdy.ai/api/search-image?query=educational%20institution%20administrative%20office%20with%20organized%20school%20supplies%20professional%20academic%20environment%20clean%20workspace%20contemporary%20furniture%20natural%20lighting%20organized%20materials&width=600&height=400&seq=sector-educacion-img&orientation=landscape"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-blue-900/70 to-transparent"></div>
                <div className="absolute top-4 right-4 w-12 h-12 bg-white rounded-lg flex items-center justify-center shadow-lg">
                  <i className="ri-graduation-cap-line text-2xl text-blue-700"></i>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Educación</h3>
                <p className="text-gray-600 mb-4">Escuelas, universidades e institutos</p>
                <div className="border-t border-gray-200 pt-4">
                  <p className="text-sm font-semibold text-gray-700 mb-2">Productos destacados:</p>
                  <ul className="space-y-1">
                    <li className="flex items-start gap-2 text-sm text-gray-600">
                      <i className="ri-checkbox-circle-line text-blue-700 mt-0.5"></i>
                      <span>Material didáctico</span>
                    </li>
                    <li className="flex items-start gap-2 text-sm text-gray-600">
                      <i className="ri-checkbox-circle-line text-blue-700 mt-0.5"></i>
                      <span>Listas escolares</span>
                    </li>
                    <li className="flex items-start gap-2 text-sm text-gray-600">
                      <i className="ri-checkbox-circle-line text-blue-700 mt-0.5"></i>
                      <span>Suministros administrativos</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            
            {/* Sector 6 */}
            <div className="group bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-500 hover:-translate-y-2 opacity-100 translate-y-0">
              <div className="relative h-48 overflow-hidden">
                <img
                  alt="Hotelería"
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  src="https://readdy.ai/api/search-image?query=hotel%20reception%20desk%20with%20organized%20office%20supplies%20professional%20hospitality%20environment%20clean%20contemporary%20design%20natural%20lighting%20elegant%20workspace%20minimalist%20aesthetic&width=600&height=400&seq=sector-hoteleria-img&orientation=landscape"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-blue-900/70 to-transparent"></div>
                <div className="absolute top-4 right-4 w-12 h-12 bg-white rounded-lg flex items-center justify-center shadow-lg">
                  <i className="ri-hotel-line text-2xl text-blue-700"></i>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Hotelería</h3>
                <p className="text-gray-600 mb-4">Hoteles, restaurantes y servicios turísticos</p>
                <div className="border-t border-gray-200 pt-4">
                  <p className="text-sm font-semibold text-gray-700 mb-2">Productos destacados:</p>
                  <ul className="space-y-1">
                    <li className="flex items-start gap-2 text-sm text-gray-600">
                      <i className="ri-checkbox-circle-line text-blue-700 mt-0.5"></i>
                      <span>Amenidades de oficina</span>
                    </li>
                    <li className="flex items-start gap-2 text-sm text-gray-600">
                      <i className="ri-checkbox-circle-line text-blue-700 mt-0.5"></i>
                      <span>Material operativo</span>
                    </li>
                    <li className="flex items-start gap-2 text-sm text-gray-600">
                      <i className="ri-checkbox-circle-line text-blue-700 mt-0.5"></i>
                      <span>Consumibles administrativos</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Casos de Éxito */}
      <section className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-8 lg:px-16">
          <div className="text-center mb-16 transition-all duration-1000 opacity-100 translate-y-0">
            <span className="inline-block bg-amber-100 text-amber-700 text-sm font-semibold px-4 py-1.5 rounded-full mb-4 tracking-wide uppercase">
              Casos de Éxito
            </span>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">Empresas que crecieron con nosotros</h2>
            <p className="text-lg text-gray-500 max-w-2xl mx-auto">
              No solo somos proveedores — somos el aliado estratégico que acompaña el crecimiento de tu negocio desde el primer pedido hasta la quinta sucursal.
            </p>
          </div>
          
          <div className="flex flex-col gap-12">
            {/* Caso 1 */}
            <div className="bg-white rounded-2xl shadow-md hover:shadow-xl overflow-hidden transition-all duration-700 opacity-100 translate-y-0">
              <div className="flex flex-col lg:flex-row">
                <div className="lg:w-1/2 h-64 lg:h-auto flex-shrink-0">
                  <img
                    alt="De 2 a 5 sucursales abastecidas sin interrupciones"
                    className="w-full h-full object-cover object-top"
                    src="https://public.readdy.ai/ai/img_res/f2e07e0aa9cf582aed69507186040d8d.jpg"
                  />
                </div>
                <div className="lg:w-1/2 p-10 flex flex-col justify-center">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-lg">
                      <i className="ri-store-2-line text-gray-700 text-xl"></i>
                    </div>
                    <span className="text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider bg-amber-100 text-amber-700">
                      Expansión Multi-Sucursal
                    </span>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4 leading-snug">
                    De 2 a 5 sucursales abastecidas sin interrupciones
                  </h3>
                  <p className="text-gray-600 leading-relaxed mb-8">
                    Una cadena de papelerías con presencia en universidades de Puebla comenzó confiando en nosotros para el suministro de dos establecimientos. La consistencia en entregas, la variedad de producto y el trato personalizado hicieron el resto: hoy abastecemos sus 5 sucursales activas. Más de un año de relación comercial ininterrumpida lo dice todo.
                  </p>
                  <div className="grid grid-cols-3 gap-4 pt-6 border-t border-gray-100">
                    <div className="text-center">
                      <div className="text-2xl font-extrabold text-gray-900">5</div>
                      <div className="text-xs text-gray-500 mt-1 leading-tight">Sucursales abastecidas</div>
                    </div>
                    <div className="text-center">
                      <div className="text-2xl font-extrabold text-gray-900">+12</div>
                      <div className="text-xs text-gray-500 mt-1 leading-tight">Meses de relación continua</div>
                    </div>
                    <div className="text-center">
                      <div className="text-2xl font-extrabold text-gray-900">×2.5</div>
                      <div className="text-xs text-gray-500 mt-1 leading-tight">Crecimiento en volumen</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Caso 2 */}
            <div className="bg-white rounded-2xl shadow-md hover:shadow-xl overflow-hidden transition-all duration-700 opacity-100 translate-y-0">
              <div className="flex flex-col lg:flex-row-reverse">
                <div className="lg:w-1/2 h-64 lg:h-auto flex-shrink-0">
                  <img
                    alt="Proveedor oficial de toda una cadena de restaurantes en Puebla"
                    className="w-full h-full object-cover object-top"
                    src="https://readdy.ai/api/search-image?query=elegant%20restaurant%20interior%20warm%20lighting%20wooden%20tables%20wine%20glasses%20sophisticated%20dining%20room%20Puebla%20Mexico%20upscale%20ambiance%20modern%20decor&width=700&height=420&seq=case-restaurante-puebla&orientation=landscape"
                  />
                </div>
                <div className="lg:w-1/2 p-10 flex flex-col justify-center">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-lg">
                      <i className="ri-restaurant-line text-gray-700 text-xl"></i>
                    </div>
                    <span className="text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider bg-rose-100 text-rose-700">
                      Sector Restaurantero
                    </span>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4 leading-snug">
                    Proveedor oficial de toda una cadena de restaurantes en Puebla
                  </h3>
                  <p className="text-gray-600 leading-relaxed mb-8">
                    Una reconocida cadena de restaurantes en Puebla nos eligió como su proveedor de confianza para todas sus sucursales activas. Más allá del suministro regular, también apoyamos el abastecimiento inicial de nuevas aperturas, garantizando que cada nueva sucursal arranque con todo lo necesario desde el primer día. Así se construye una alianza real.
                  </p>
                  <div className="grid grid-cols-3 gap-4 pt-6 border-t border-gray-100">
                    <div className="text-center">
                      <div className="text-2xl font-extrabold text-gray-900">100%</div>
                      <div className="text-xs text-gray-500 mt-1 leading-tight">Sucursales atendidas</div>
                    </div>
                    <div className="text-center">
                      <div className="text-2xl font-extrabold text-gray-900">Sí</div>
                      <div className="text-xs text-gray-500 mt-1 leading-tight">Nuevas aperturas apoyadas</div>
                    </div>
                    <div className="text-center">
                      <div className="text-2xl font-extrabold text-gray-900">Integral</div>
                      <div className="text-xs text-gray-500 mt-1 leading-tight">Tipo de servicio</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="mt-16 text-center transition-all duration-1000 delay-500 opacity-100 translate-y-0">
            <p className="text-gray-500 text-base mb-2">¿Tu empresa podría ser el próximo caso de éxito?</p>
            <p className="text-xl font-bold text-gray-900">Contáctanos hoy y descubre cómo podemos crecer juntos.</p>
          </div>
        </div>
      </section>
      
      {/* CTA Final */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-8 lg:px-16">
          <div className="bg-gradient-to-r from-blue-700 to-blue-900 rounded-2xl p-12 lg:p-16 text-center transition-all duration-1000 opacity-100 scale-100">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
                Comienza a Optimizar tus Suministros Hoy
              </h2>
              <p className="text-xl text-white/90 mb-10 leading-relaxed">
                Se parte de las empresas de Puebla que ya confían en CX Comercializadora para sus suministros de oficina. Solicita una cotización sin compromiso y descubre cómo podemos ayudarte.
              </p>
              <div className="flex flex-wrap gap-4 justify-center mb-10">
                <a
                  href="https://wa.me/+522228121142?text=Hola,%20quiero%20información%20sobre%20soluciones%20empresariales"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-green-600 hover:bg-green-700 text-white px-10 py-4 rounded-lg text-base font-semibold transition-all cursor-pointer whitespace-nowrap hover:scale-105 transform flex items-center gap-3 shadow-2xl"
                >
                  <i className="ri-whatsapp-line text-2xl"></i>
                  Contactar por WhatsApp
                </a>
                <Link
                  to="/contacto"
                  className="bg-white hover:bg-gray-100 text-blue-700 px-10 py-4 rounded-lg text-base font-semibold transition-all cursor-pointer whitespace-nowrap hover:scale-105 transform shadow-2xl"
                >
                  Solicitar Cotización
                </Link>
              </div>
              <div className="flex justify-center mt-12">
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 w-full max-w-2xl">
                  <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
                    <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3">
                      <i className="ri-time-line text-4xl text-white"></i>
                    </div>
                    <div className="text-white font-semibold">Respuesta Rápida</div>
                  </div>
                  <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
                    <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3">
                      <i className="ri-shield-check-line text-4xl text-white"></i>
                    </div>
                    <div className="text-white font-semibold">Sin compromiso</div>
                  </div>
                  <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
                    <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3">
                      <i className="ri-user-star-line text-4xl text-white"></i>
                    </div>
                    <div className="text-white font-semibold">Asesoría Experta</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default SolucionesEmpresas;